import * as Yup from 'yup'

export interface AccumulationCurrencyInstructionDetails {
  id: number
  assetHolderId: number
  projectId: number
  projectName: string
  projectStatus: string
  currencyId: number
  currencyUnit: string
  expiredAt: string | null
  supersededBy: number | undefined
}

export interface CharityContributionInstructionDetails {
  id: number
  assetHolderId: number
  projectId: number
  projectName: string
  projectStatus: string
  organisationId: number
  organisationName: string
  percentageDistribution: number
  expiredAt: string | null
  supersededBy: number | undefined
}

export interface LegacyKycResultDto {
  id: number
  assetHolderId: number
  provider: string
  tierLevel: string
  status: string
  kycDateTime: string
  narrative: string
  response: string
}

export interface AssetHolderRole {
  id: number
  legacyRole: string
}

export interface UsCitizenStatusDto {
  isSelfDeclaredCitizen: boolean
  isUsCitizen: boolean
  isOnCitizenWhitelist: boolean
}

// + sync from back-end-v2/src/domains/asset_holding/api-schema-dtos/AssetHolderCrudDtos.ts
export interface AssetHolderUpdateDto {
  assetHolderId: number
  partyId: number
  legacyFirstName: string
  legacyLastName: string
  dateRegistered: string | null
  registrationState: string
  legacyDob: string | null
  legacyPhoneNumber: string | null
  legacyAddress: string | null
  legacyCity: string | null
  legacyPostalCode: string | null
  legacyCountry: string | null
  legacyRegion: string | null
  websiteUrl: string | null
  legacyEmailAddress: string
  legacyEarlyAccess: boolean
  twoFAStatus: boolean
  lastLoginAt: Date | null
  vipMember: boolean

  overrideLockRequested: boolean

  agreeToMarketing: boolean

  usCitizenStatus: UsCitizenStatusDto
  assetHolderRoles: AssetHolderRole[]
  assetHolderKycResults: LegacyKycResultDto[]
  accumulationInstructions: AccumulationCurrencyInstructionDetails[]
  charityInstructions: CharityContributionInstructionDetails[]

  latestLegacyKycResult: LegacyKycResultDto | null
  hasPassedKyc: boolean
  kycRequiredForDonations: boolean
  totalWalletBalanceZar: number

}

export interface AssetHolderUpdatePayload {
  legacyFirstName: string
  legacyLastName: string
  legacyDob: string
  legacyPhoneNumber: string | null
  legacyAddress: string
  legacyCity: string
  legacyPostalCode: string
  legacyRegion: string
  legacyCountry: string
  isUsCitizen: boolean
  agreeToMarketing: boolean
  otp: string
}

export interface AssetHolderUpdateForm {
  legacyFirstName: string
  legacyLastName: string
  legacyDob: string
  legacyPhoneNumber: string | null
  legacyAddress: string
  legacyCity: string
  legacyPostalCode: string
  legacyRegion: string
  legacyCountry: string
  acceptTermsAndConditionsAndPrivacyPolicy: boolean
  agreeToMarketing: boolean
  unethicalProfitAccepted: boolean
  isUsCitizen: boolean
  otp: string
}

export const validateUpdateProfileForm = (): any => {
  return Yup.object().shape({
    legacyFirstName: Yup.string().required('First Name'),
    legacyLastName: Yup.string().required('Last Name'),
    legacyDob: Yup.date().required('Date of Birth'),
    legacyPhoneNumber: Yup.string().nullable('Phone Number'),
    legacyAddress: Yup.string().required('Address'),
    legacyCity: Yup.string().required('City'),
    legacyPostalCode: Yup.string().required('Postal Code'),
    legacyRegion: Yup.string().required('State / Province / Region'),
    legacyCountry: Yup.string().required('Country'),
    acceptTermsAndConditionsAndPrivacyPolicy: Yup.boolean().isTrue('Agree to Terms and Conditions').required(),
    agreeToMarketing: Yup.boolean().required(),
    unethicalProfitAccepted: Yup.boolean().isTrue('Agree to our Ethical Profile Policy').required(),
    isUsCitizen: Yup.boolean().required()
  })
}

export interface UpdateAssetHolderEmailAddressPayload {
  assetHolderId: number
  emailAddress: string
  password: string
  otp: string
}

export interface UpdateAssetHolderEmailAddressForm {
  emailAddress: string
  password: string
}

export const validateUpdateEmailForm = (): any => {
  return Yup.object().shape({
    emailAddress: Yup.string()
      .email('Please enter a valid email address')
      .required('Please enter your email address'),
    password: Yup.string().required('Please enter your password')
  })
}
